import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import Paths from '@/configs/router/paths';
import styles from './index.module.scss';
import NoticeIcon from './images/notice.svg?react';
import SecurityIcon from './images/security.svg?react';
import PrivacyIcon from './images/privacy.svg?react';
import AboutIcon from './images/about.svg?react';

const SettingMenu = () => {
  const location = useLocation();
  const items: MenuProps['items'] = [
    {
      key: Paths.SETTINGS_NOTIFICATIONS,
      label: <Link to={Paths.SETTINGS_NOTIFICATIONS}>Notifications and Sounds</Link>,
      icon: <NoticeIcon />,
    },
    {
      type: 'divider',
    },
    {
      key: Paths.SETTINGS_SECURITY,
      label: <Link to={Paths.SETTINGS_SECURITY}>Security</Link>,
      icon: <SecurityIcon />,
    },
    {
      key: Paths.SETTINGS_PRIVACY,
      label: <Link to={Paths.SETTINGS_PRIVACY}>Privacy</Link>,
      icon: <PrivacyIcon />,
    },
    {
      type: 'divider',
    },
    {
      key: Paths.SETTINGS_ABOUT,
      label: <Link to={Paths.SETTINGS_ABOUT}>About HaloChat</Link>,
      icon: <AboutIcon />,
    },
  ];

  return (
    <div className={styles.settingMenu}>
      <Menu className={styles.menu} items={items} selectedKeys={[location.pathname]} />
    </div>
  );
};
export default SettingMenu;
